import EventEmitter from 'eventemitter3';
import { Settings } from '../../Settings';
import { FrameExtractor } from './FrameExtractor';
export class VideoEncoderWrapper extends EventEmitter {
    videoEncoderWorker;
    videoFrameExtractor;
    track;
    constructor() {
        super();
        this.videoEncoderWorker = new Worker(new URL('./workers/videoencoder.worker.ts', import.meta.url));
        this.videoEncoderWorker.onmessage = (e) => {
            const { type, data } = e.data;
            switch (type) {
                case 'videoData':
                    this.emit('videoData', data);
                    break;
                case 'startCompleted':
                    this.emit('workerStarted');
                    break;
            }
        };
    }
    startWorker(frameRate, videoTrack) {
        return new Promise((resolve, _reject) => {
            this.once('workerStarted', () => {
                resolve();
            });
            this.videoEncoderWorker?.postMessage({
                type: 'start',
                frameRate: frameRate,
                videoTrack: videoTrack,
            });
        });
    }
    async start(videoTrack) {
        this.track = videoTrack;
        // Create FrameExtractor in worker on Safari
        // in main thread on Chrome
        const createFrameExtractorInWorker = typeof MediaStreamTrackProcessor === 'undefined';
        console.log('start createFrameExtractorInWorker', createFrameExtractorInWorker);
        if (this.videoFrameExtractor) {
            await this.videoFrameExtractor.stop();
        }
        await this.startWorker(videoTrack.getSettings().frameRate ??
            Settings.videoEncoderDefaultFrameRate, createFrameExtractorInWorker ? videoTrack : undefined);
        if (!createFrameExtractorInWorker) {
            this.videoFrameExtractor = new FrameExtractor(videoTrack);
            this.videoFrameExtractor.emitter.on('frame', (frame) => {
                this.videoEncoderWorker?.postMessage({
                    type: 'feedVideoFrame',
                    videoFrame: frame,
                }, [frame]);
            });
            this.videoFrameExtractor.start();
        }
    }
    setVideoEncodingBitrate(bitrate) {
        this.videoEncoderWorker?.postMessage({
            type: 'setVideoEncodingBitrate',
            bitrate: bitrate,
        });
    }
    getTrack() {
        if (!this.track) {
            throw new Error('No track information. Call `start` first.');
        }
        return this.track;
    }
}
